import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useCallback, useState } from "react";
import styled, { useTheme } from "styled-components";
import TranslationContext from "../providers/TranslationContext";
import withComponentOverride from "../withComponentOverride";
const EditContainer = withComponentOverride(styled.form `
	display: flex;
`);
const SubmitButton = withComponentOverride(styled.button `
	border: 0;
	cursor: pointer;
	font-weight: 500;
	line-height: 40px;
	margin: 0;
	padding: 0 10px;
	flex-shrink: 0;

	${({ theme: { variant } }) => {
    if (variant === "desktop") {
        return `border-radius: 0 3px 3px 0;`;
    }
    return `font-weight: 700;
		padding: 0 16px;`;
}};

	background: ${(props) => {
    return props.theme.colors.btnBg;
}};
	color: ${(props) => {
    return props.theme.colors.btnColor;
}};

	&:hover {
		background: ${(props) => {
    return props.theme.colors.btnBgHover;
}};
	}

	&:disabled {
		pointer-events: none;
		opacity: 0.5;
	}
`);
const TextInput = withComponentOverride(styled.input `
	border: 0;
	appearance: none;
	border-radius: 0;
	height: 40px;
	padding: ${({ theme: { variant } }) => {
    return variant === "desktop" ? "4px 10px" : "0 15px";
}};
	width: 100%;

	${({ theme: { variant } }) => {
    if (variant === "desktop") {
        return `border-radius: 3px 0 0 3px;`;
    }
}};

	background: ${(props) => {
    return props.theme.colors.inputBg;
}};
	color: ${(props) => {
    return props.theme.colors.inputColor;
}};

	&::placeholder {
		color: ${(props) => {
    return props.theme.colors.placeholderColor;
}};
	}

	&:focus {
		background: ${(props) => {
    return props.theme.colors.inputBgFocus;
}};
	}

	&:disabled {
		opacity: 0.5;
	}
`);
const spamTime = 2;
const EditArea = ({ sendMessage, isDisabled }) => {
    const { buttonText, placeholderText, initializingText } = useContext(TranslationContext);
    const { components } = useTheme();
    const [lastMessageSendTime, setLastMessageSendTime] = useState(0);
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const input = e.currentTarget.elements[0];
        const value = input.value.trim();
        if (!value) {
            return;
        }
        const currentSendTime = Math.round(new Date().getTime() / 1000);
        if (currentSendTime - lastMessageSendTime < spamTime) {
            return;
        }
        setLastMessageSendTime(currentSendTime);
        sendMessage(value);
        input.value = "";
    }, [lastMessageSendTime, sendMessage]);
    return (_jsxs(EditContainer, { onSubmit: handleSubmit, componentOverride: components?.EditContainer, children: [_jsx(TextInput, { type: "text", disabled: isDisabled, placeholder: !isDisabled ? placeholderText : initializingText, "data-testid": "support-chat-edit-input", "data-hj-suppress": "", maxLength: 400, componentOverride: components?.TextInput }), _jsx(SubmitButton, { type: "submit", "data-testid": "support-chat-edit-button", componentOverride: components?.SubmitButton, disabled: isDisabled, children: buttonText })] }));
};
export default EditArea;
